const AVATAR_COLORS = {
  A: '#E0CCFF', // dataviz-violet-20
  B: '#C9D5FB', // dataviz-lilac-20
  C: '#B2E8FF', // dataviz-cyan-20
  D: '#ACFAF9', // dataviz-teal-20
  E: '#A6FFC0', // dataviz-lime-20
  F: '#E0CCFF', // dataviz-violet-20
  G: '#C9D5FB', // dataviz-lilac-20
  H: '#B2E8FF', // dataviz-cyan-20
  I: '#ACFAF9', // dataviz-teal-20
  J: '#A6FFC0', // dataviz-lime-20
  K: '#E0CCFF', // dataviz-violet-20
  L: '#C9D5FB', // dataviz-lilac-20
  M: '#B2E8FF', // dataviz-cyan-20
  N: '#ACFAF9', // dataviz-teal-20
  O: '#A6FFC0', // dataviz-lime-20
  P: '#E0CCFF', // dataviz-violet-20
  Q: '#C9D5FB', // dataviz-lilac-20
  R: '#B2E8FF', // dataviz-cyan-20
  S: '#ACFAF9', // dataviz-teal-20
  T: '#A6FFC0', // dataviz-lime-20
  U: '#E0CCFF', // dataviz-violet-20
  V: '#C9D5FB', // dataviz-lilac-20
  W: '#B2E8FF', // dataviz-cyan-20
  X: '#ACFAF9', // dataviz-teal-20
  Y: '#A6FFC0', // dataviz-lime-20
  Z: '#E0CCFF', // dataviz-violet-20
} as const

/**
 * Gets a background color for an avatar based on the first letter of the first name
 * @param fullName - The full name of the user
 * @returns A hex color code from the dataviz color palette
 */
export function getAvatarColor(fullName: string): string {
  if (!fullName) return '#DDE5ED' // neutral-30 as default

  const firstLetter = fullName.trim().charAt(0).toUpperCase()
  return AVATAR_COLORS[firstLetter as keyof typeof AVATAR_COLORS] ?? '#DDE5ED'
}
